function getAuthHeaders() {
  const token: any = localStorage.getItem('ims-token') || ''
  return {
    'x-api-key': 'yoddha-service',
    'Content-Type': 'application/json',
    Authorization: token ? JSON.parse(token) : ''
  }
}

export default getAuthHeaders
